export const SUPPORTED_LOCALES = ["en", "tr", "es", "pt", "it", "fr", "hi"] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const FALLBACK_LOCALE: SupportedLocale = "en";

export const LOCAL_STORAGE_KEY = "refabric_lang";

export const NAMESPACES = [
  "common",
  "validation",
  "errors",
  "snackbar",
  "auth",
  "account",
  "billing",
  "home",
  "photoshoot",
  "design-canvas",
  "tech-pack",
  "training",
  "trends",
  "brand-dna",
  "assets",
  "color-palettes",
  "brand-kits",
  "edit-design",
  "marketplace",
  "bulk-process",
  "academy",
  "collection-range-plan",
  "notifications",
  "miro",
] as const;
export type Namespace = typeof NAMESPACES[number];

export const DEFAULT_NAMESPACE: Namespace = "common";

export const isSupportedLocale = (value: unknown): value is SupportedLocale => typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value);
